<template>
  <!-- 出库单详情（新增/编辑/查看） -->
  <div class="out-stock-detail">
    <list-page :status-name="dataDetail.statusName" :status-type="dataDetail.status === 1001? 'info': 'success'">
      <div class="form-div">
        <form-tag label="单据信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="单据编号">
            <el-input v-model="dataDetail.billNo" placeholder="系统自动生成" disabled/>
          </form-item>
          <form-item label="出库类型" :required="true" name="billType" error-message="请选择出库类型">
            <el-select v-model="dataDetail.billType" placeholder="请选择出库类型">
              <el-option v-for="t in billTypeOptions" :key="t.code" :value="t.code" :label="t.name"/>
            </el-select>
          </form-item>
          <form-item label="单据日期">
            <el-date-picker v-model="dataDetail.billDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%"/>
          </form-item>
          <form-item label="仓库" :required="true" name="warehouseId" error-message="请选择仓库">
            <el-select v-model="dataDetail.warehouseId" placeholder="请选择仓库">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="经手人">
            <employee-select v-model="dataDetail.handlerId" :disabled="isReadonly || dataDetail.status === 2"
                             @change="handlerChange"/>
          </form-item>
          <form-item label="操作员">
            <el-input v-model="dataDetail.operatorName" disabled/>
          </form-item>
          <form-item label="部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" :disabled="isReadonly || dataDetail.status === 2" placeholder="请选择部门"/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input type="textarea" v-model="dataDetail.remark" placeholder="备注信息"/>
          </form-item>
        </form-items>
        <form-tag label="明细信息"/>
      </div>
      <list-table class="list-table" background-color="#FFF">
        <product-select-table ref="itemTable" v-model="dataDetail.items" :query-api="queryProductByPartner" :multi="true" @table-select-multi="addList2Items">
          <yq-table-column label="批次号" prop="batchNumber" width="160rem">
            <template v-slot="{row}">
              <el-input v-model="row.batchNumber" placeholder="批次号（可选）" :disabled="isReadonly"/>
            </template>
          </yq-table-column>
          <yq-table-column label="单位" width="120rem" align="center">
            <template v-slot="{row}">
              <el-select v-model="row.skuUnitId" :disabled="isReadonly" placeholder="请选择单位" @change="rowQtyChange(row)" style="width:100%">
                <el-option v-for="u in row.units" :key="u" :value="u" :label="unitName(u)"/>
              </el-select>
            </template>
          </yq-table-column>
          <yq-table-column label="数量" prop="skuQty" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.skuQty" :min="1" controls-position="right" :disabled="isReadonly" style="width:100%" @change="rowPriceOrQtyChange(row)"/>
            </template>
          </yq-table-column>
          <yq-table-column label="单位价格" prop="skuPrice" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.skuPrice" :min="0" :precision="2" controls-position="right" :disabled="isReadonly" style="width:100%" @change="rowPriceOrQtyChange(row)"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位数量" prop="qty" width="120rem" align="right">
            <template v-slot="{row}">
              <span>{{row.qty}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位单价" prop="price" width="130rem" />
          <yq-table-column label="金额" prop="amount" width="120rem" align="right">
            <template v-slot="{row}">{{formatAmount(row)}}</template>
          </yq-table-column>
          <yq-table-column label="操作" width="90rem" align="center" v-if="!isReadonly">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteItem($index)">移除</table-button>
            </template>
            <template #header>
              <table-button :disabled="isReadonly" @click="addItem"><yq-icon name="element-ui_plus"/>添加明细</table-button>
            </template>
          </yq-table-column>
        </product-select-table>

        <template v-if="hasSerialProduct">
          <form-tag label="序列号（商品开启序列号时填写）"/>
          <list-table>
            <div class="serial-input-area">
              <el-input v-model="serialInput" placeholder="扫码 / 输入序列号后回车添加" :disabled="isReadonly"
                        @keydown.enter="addSerial"/>
              <div class="serial-tags">
                <span class="serial-tag" v-for="(s, i) in dataDetail.serialList || []" :key="i">
                  {{s}}
                  <yq-icon v-if="!isReadonly" name="element-ui_close" @click="dataDetail.serialList.splice(i, 1)"/>
                </span>
              </div>
            </div>
            <div class="tip-warn">⚠️ 出库序列号必须为当前库存中存在的序列号，出库后自动核销。</div>
          </list-table>
        </template>
      </list-table>

      <form-page :show-page="false" v-if="!isReadonly">
        <template #left>单据金额: {{dataDetail.totalAmount}}</template>
        <page-button :disabled="dataDetail.status > 1001" type="write" el-type="primary" @click="saveData">保存草稿</page-button>
        <page-button :disabled="dataDetail.status > 1001" type="write" el-type="success" @click="submitData">提交单据</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqIcon from "@/components/YqIcon.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import CustomerSelect from "@/components/h5/partner/CustomerSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import outboundOrderApi from "@/api/normal/stock/outboundOrderApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "OutStockDetail",
  components: {
    YqIcon, ProductSelectTable, YqTableColumn, TableButton, FormItems, FormItem, FormTag,
    EmployeeSelect, DepartSelect, CustomerSelect,
    PageButton, ListPage, ListTable, FormPage
  },
  data() {
    return {
      billTypeOptions: [],
      warehouseOptions: [],
      unitList: [],
      departTree: [],
      dataDetail: {},
      serialInput: "",
      isReadonly: false,
      userInfo: {},
    };
  },
  computed: {
    hasSerialProduct() {
      return (this.dataDetail.items || []).some(it => it.serialEnabled === 1);
    }
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // 不使用页面缓存
    this.userInfo = await Util.getUserInfo();
    this.init();
    let id = this.route.query.id;
    if (id) {
      this.isReadonly = this.route.query.view === '1';
      this.findById(id);
    } else {
      this.initNew();
    }
    Util.getSystemSettingOptions("STOCK_OUT_TYPE").then(list => this.billTypeOptions = list);
  },
  methods: {
    // 查询商品列表，用于下单，包含价格方案
    queryProductByPartner(data) {
      return new Promise(resolve => {
        commonDataApi.queryProductListByPartner({
          ...data,
          partnerId: this.dataDetail.customerId
        }).then(res => resolve(res))
      })
    },
    init() {
      // 仓库/单位下拉 + 部门树
      commonDataApi.queryAllWarehouse().then(warehouses => {
        this.warehouseOptions = warehouses || [];
        // 主部门唯一仓库自动选中
        if (this.warehouseOptions.length === 1) {
          this.dataDetail.warehouseId = this.warehouseOptions[0].id;
          return;
        }
        let count = 0;
        let warehouseId = "";
        for (let i = 0; i < this.warehouseOptions.length; i++) {
          if (this.userInfo.mainDepartCode === this.warehouseOptions[i].departCode) {
            count++;
            warehouseId = this.warehouseOptions[i].id;
          }
        }
        if (count === 1) {
          this.dataDetail.warehouseId = warehouseId;
        }
      });
      commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(units => this.unitList = units || []);
      commonApi.queryDepartList().then(departs => this.departTree = departs || []);
    },
    // 经手人 change 事件回填名称
    handlerChange(data) {
      this.dataDetail.handlerName = (data && data.employeeName) || "";
    },
    unitName(unitId) {
      if (!unitId) return "";
      let u = this.unitList.find(it => it.dictCode === unitId);
      return u ? u.dictName : "";
    },
    formatAmount(row) {
      let amount = row.amount != null ? Number(row.amount) : ((Number(row.skuQty) || 0) * (Number(row.skuPrice) || 0));
      return amount.toFixed(2);
    },
    async findById(id) {
      const res = await outboundOrderApi.findById(id);
      this.dataDetail = res;
      this.dataDetail.items = (res.itemList || []).map(it => {
        const row = {
          skuId: it.skuId || it.productId,
          productId: it.productId,
          productName: it.productName || "",
          unitIdBase: it.unitIdBase || it.skuUnitId,
          unitIdMiddle: it.unitIdMiddle,
          unitIdLarge: it.unitIdLarge,
          batchNumber: it.batchNumber,
          skuUnitId: it.skuUnitId || it.unitIdBase,
          skuQty: it.skuQty != null ? it.skuQty : it.qty,
          skuPrice: it.skuPrice != null ? it.skuPrice : it.price,
          qty: it.qty,
          price: it.price,
          amount: it.amount,
        };
        row.units = [row.unitIdBase, row.unitIdMiddle, row.unitIdLarge].filter(Boolean);
        return row;
      });
      if (res.serialNumber) {
        try {
          this.dataDetail.serialList = JSON.parse(res.serialNumber);
        } catch (e) {
          this.dataDetail.serialList = [];
        }
      } else {
        this.dataDetail.serialList = [];
      }
    },
    initNew() {
      // 经手人/操作员/部门默认当前用户；仓库自动选中由 init 的 queryAllWarehouse 处理
      this.dataDetail = {
        billNo: "",
        billType: 101,
        billDate: this.today(),
        customerId: "",
        warehouseId: this.dataDetail.warehouseId,
        remark: "",
        handlerId: this.userInfo.id,
        handlerName: this.userInfo.employeeName,
        operatorId: this.userInfo.id,
        operatorName: this.userInfo.employeeName,
        departCode: this.userInfo.mainDepartCode,
        items: [{skuId: "", productId: "", productName: "", skuUnitId: "", skuQty: 1, qty: 1, batchNumber: ""}],
        serialList: [],
      };
    },
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    addItem() {
      this.$refs.itemTable.toSelectMore();
    },
    addList2Items(list) {
      this.fillItems(this.dataDetail.items, list);
    },
    fillItems(items, list) {
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (items[i].skuId === list[j].id) {
            items[i].productId = list[j].parentId || list[j].id;
            items[i].productName = list[j].productName;
            items[i].unitIdBase = list[j].unitIdBase;
            items[i].unitIdMiddle = list[j].unitIdMiddle;
            items[i].unitIdLarge = list[j].unitIdLarge;
            items[i].middleRate = list[j].middleRate;
            items[i].largeRate = list[j].largeRate;
            items[i].units = [list[j].unitIdBase, list[j].unitIdMiddle, list[j].unitIdLarge].filter(Boolean);
            items[i].salePriceBase = list[j].salePriceBase || 0;
            items[i].salePriceMiddle = list[j].salePriceMiddle || 0;
            items[i].salePriceLarge = list[j].salePriceLarge || 0;
            items[i].serialEnabled = list[j].serialEnabled;
            items[i].skuUnitId = list[j].unitIdBase;
            items[i].skuQty = items[i].skuQty || 1;
            items[i].skuPrice = list[j].salePriceBase || 0;
            items[i].qty = items[i].qty || 1;
            items[i].amount = (Number(items[i].skuQty) || 0) * (Number(items[i].skuPrice) || 0);
            this.rowQtyChange(items[i]);
          }
        }
      }
    },
    // 换单位：重算基本单位数量，并取所选单位对应的价格到 sku_price
    rowQtyChange(row) {
      if (!row) return;
      let rate = 1;
      if (row.skuUnitId && row.skuUnitId === row.unitIdMiddle && row.middleRate) {
        rate = Number(row.middleRate);
      } else if (row.skuUnitId && row.skuUnitId === row.unitIdLarge && row.largeRate) {
        rate = Number(row.largeRate);
      }
      row.qty = Number(((Number(row.skuQty) || 0) * rate).toFixed(4));
      // 取所选单位对应价格
      if (row.skuUnitId === row.unitIdMiddle) {
        row.skuPrice = Number(row.salePriceMiddle) || 0;
      } else if (row.skuUnitId === row.unitIdLarge) {
        row.skuPrice = Number(row.salePriceLarge) || 0;
      } else {
        row.skuPrice = Number(row.salePriceBase) || 0;
      }
      this.rowPriceChange(row);
    },
    rowPriceOrQtyChange(row) {
      if (!row) return;
      let rate = 1;
      if (row.skuUnitId && row.skuUnitId === row.unitIdMiddle && row.middleRate) {
        rate = Number(row.middleRate);
      } else if (row.skuUnitId && row.skuUnitId === row.unitIdLarge && row.largeRate) {
        rate = Number(row.largeRate);
      }
      row.qty = Number(((Number(row.skuQty) || 0) * rate).toFixed(4));
      this.rowPriceChange(row);
    },
    // 数量/单位价格变更：金额 = 单位数量 × 单位价格；基本单位单价 = 金额 / 基本单位数量
    rowPriceChange(row) {
      if (!row) return;
      row.amount = Number(((Number(row.skuQty) || 0) * (Number(row.skuPrice) || 0)).toFixed(4));
      if (Number(row.qty) > 0) {
        row.price = Number((row.amount / Number(row.qty)).toFixed(4));
      } else {
        row.price = 0;
      }
    },
    deleteItem(index) {
      this.dataDetail.items.splice(index, 1);
      this.$refs.itemTable.refresh();
    },
    addSerial() {
      let s = this.serialInput.trim();
      if (!s) return;
      if (!this.dataDetail.serialList) this.dataDetail.serialList = [];
      this.dataDetail.serialList.push(s);
      this.serialInput = "";
    },
    // 构建明细 + 基础校验，返回构建好的提交数据（校验失败返回 null）
    buildSubmitData() {
      if (!this.dataDetail.warehouseId) {
        this.$message.error("请选择仓库");
        return null;
      }
      const items = (this.dataDetail.items || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        skuUnitId: it.skuUnitId || it.unitIdBase,
        skuQty: it.skuQty != null ? it.skuQty : it.qty,
        skuPrice: it.skuPrice != null ? it.skuPrice : 0,
        batchNumber: it.batchNumber,
        qty: it.qty,
        price: it.price,
        amount: it.amount != null ? it.amount : (Number(it.skuQty) || 0) * (Number(it.skuPrice) || 0),
      }));
      if (items.length === 0) {
        this.$message.error("请添加明细");
        return null;
      }
      // 强制序列号商品校验
      if (this.hasSerialProduct && (!this.dataDetail.serialList || this.dataDetail.serialList.length === 0)) {
        this.$message.error("开启强制序列号的商品须填写序列号才能提交");
        return null;
      }
      const submitData = {...this.dataDetail, itemList: items};
      if (this.dataDetail.serialList && this.dataDetail.serialList.length > 0) {
        submitData.serialNumber = JSON.stringify(this.dataDetail.serialList);
      }
      return submitData;
    },
    // 保存草稿
    saveData() {
      const submitData = this.buildSubmitData();
      if (!submitData) return;
      submitData.status = 1001;
      outboundOrderApi.save(submitData).then(() => this.router.push('/stock/outStock'));
    },
    // 提交单据（保存后提交，校验库存并扣减）
    submitData() {
      const submitData = this.buildSubmitData();
      if (!submitData) return;
      submitData.status = 1010;
      outboundOrderApi.save(submitData).then(() => this.router.push('/stock/outStock'));
    }
  }
};
</script>

<style lang="scss" scoped>
.out-stock-detail {
  height: 100%;

  .form-div {
    padding: 10px 10px 0 10px;
    background: #FFF;
  }

  .list-table {
    padding: 10px;
  }

  .add-item-btn {
    border: 1.5px dashed var(--yq-border-color);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: var(--yq-font-color-tips);
    font-size: 13px;
    cursor: pointer;
    margin: 8px 16px;

    &:hover {
      color: var(--el-color-primary);
      border-color: var(--el-color-primary);
    }
  }

  .serial-input-area {
    padding: 10px 16px;

    .serial-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 10px;

      .serial-tag {
        background: var(--el-color-primary-light-9);
        color: var(--el-color-primary);
        padding: 3px 10px;
        border-radius: 4px;
        font-size: 13px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }
    }
  }

  .tip-warn {
    font-size: 12px;
    color: var(--el-color-warning);
    background: var(--el-color-warning-light-9);
    padding: 8px 12px;
    border-radius: 4px;
    margin: 0 16px 10px;
  }
}
</style>
